import { bindContributionProvider } from "@visactor/vrender-core";

import { CanvasGroupPicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasGroupPicker } from "./group-picker";

let loaded = !1;

export function bindCanvasPickerContribution(c) {
    loaded || (loaded = !0, c.bind(CanvasGroupPicker).toDynamicValue((() => new DefaultCanvasGroupPicker)).inSingletonScope(), 
    c.bind(CanvasPickerContribution).toService(CanvasGroupPicker), bindContributionProvider(c.bind.bind(c), CanvasPickerContribution));
}
//# sourceMappingURL=module.js.map
